export class ImageRefModel {
  src: string;
  resource: string;
  typeofnode: string;
  name: string;
  height: number;
  width: number;
  tenantId: string;
  constructor(
    src: string,
    resource: string,
    typeofnode: string,
    name: string,
    height: number,
    width: number,
    tenantId: string
  ) {
    this.src = src;
    this.resource = resource;
    this.typeofnode = typeofnode;
    this.name = name;
    this.width = width;
    this.height = height;
    this.tenantId = tenantId;
  }
}
export class ImageObjectModel {
  images: ImageRefModel[];
  constructor(images: ImageRefModel[]) {
    this.images = images ? images : null;
  }
}
